module.exports = __webpack_public_path__ + "static/media/logo-camaraitiuba.2c5a77af.png";